// Added for assessment documents since we don't yet apply content types in the service
export const guessContentType = (fileName: string): string => {
    const fileExt = getFileExtension(fileName) ?? "";
    return getContentType(fileExt) || "application/octet-stream";
};

export const ACCEPTED_FILE_EXTENSIONS =
    ".pdf,.csv,.eml,.txt,.rtf,.xls,.xlsx,.json,.ppt,.pptx,.xls,.xlsx,.doc,.docx,.xml,.tif,.tiff,.jpeg,.jpg,.png,.xlsm,.msg";

const EXTENSION_TO_CONTENT_TYPE_MAP: { [key: string]: string } = {
    ".pdf": "application/pdf",
    ".csv": "text/csv",
    ".eml": "message/rfc822",
    ".txt": "text/plain",
    ".rtf": "application/rtf",
    ".xls": "application/vnd.ms-excel",
    ".xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ".json": "application/json",
    ".ppt": "application/vnd.ms-powerpoint",
    ".pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    ".doc": "application/msword",
    ".docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ".xml": "application/xml",
    ".tif": "image/tiff",
    ".tiff": "image/tiff",
    ".jpeg": "image/jpeg",
    ".jpg": "image/jpeg",
    ".png": "image/png",
    ".xlsm": "application/vnd.ms-excel.sheet.macroEnabled.12",
    ".msg": "application/vnd.ms-outlook",
};

function getContentType(extension: string): string {
    return EXTENSION_TO_CONTENT_TYPE_MAP[extension.toLowerCase()];
}

function getFileExtension(fileName: string): string | undefined {
    const lastDotIndex = fileName.lastIndexOf(".");
    if (lastDotIndex === -1 || lastDotIndex === fileName.length - 1) {
        return undefined;
    }
    return fileName.substring(lastDotIndex).toLowerCase();
}

export const MAX_FILE_SIZE = 30 * 1024 * 1024;

const INLINE_PREVIEW_CONTENT_TYPES = new Set(["application/pdf", "image/png", "image/jpeg", "image/tiff"]);

export const canPreviewInline = (fileName: string): boolean =>
    INLINE_PREVIEW_CONTENT_TYPES.has(guessContentType(fileName));
